import {Carousel as apis} from '@/api/system'

const listConfig = [
    {title: '图片地址', key: 'imageUrl'},
    {
        title: '跳转方式', key: 'jumpType', showData: {
            1: '不跳转',
            2: '内部',
            3: '外部',
        }
    },
    {title: '跳转地址', key: 'jumpUrl'},
    {
        title: '状态', key: 'status', showData: {
            1: '显示',
            2: '不显示',
        }
    },
]

const btnConfig = [
    {bg: '#19458C', title: '新 增', key: 'add', role: 'ADD'},
    {bg: '#19458C', title: '编 辑', key: 'update', role: 'Edit'},
    {bg: '#EA5B24', title: '删 除', key: 'delete', role: 'Del'},
]

function fromConfig() {
    return [
        {title: '轮播图片', value: '', key: 'imageUrl', type: 'upload', span: 12},
        {
            title: '跳转方式',
            value: '',
            key: 'jumpType',
            type: 'select',
            list: [
                {label: '不跳转', value: 1},
                {label: '内部', value: 2},
                {label: '外部', value: 3}
            ], span: 12
        },
        {title: '跳转地址', value: '', key: 'jumpUrl', type: 'input', notRequired: true, span: 12},
        {
            title: '状态',
            value: '',
            key: 'status',
            type: 'select',
            list: [
                {label: '显示', value: 1},
                {label: '不显示', value: 2}
            ], span: 12
        },
    ]
}

export default function config() {
    return {
        listConfig,
        btnConfig,
        fromConfig,
        apis
    }
}
